import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const fetchSliderApi = createApi({
  reducerPath: "sliderApi",
  baseQuery: fetchBaseQuery({
    baseUrl:
      "https://firestore.googleapis.com/v1/projects/clone-realtor-557bf/databases/(default)/documents"
  }),
  tagTypes: ["sliderApiImages"],
  endpoints: (builder) => ({
    getSliderImages: builder.query({
      query: () => "/homeImages/yqTFrTOrlXbiFL1tC4HP",
      providesTags: ["sliderApiImages"]
    })
  })
});

export const { useGetSliderImagesQuery } = fetchSliderApi;
